import { BaseModel } from "../Generics/BaseModel"
import { CompanyEntity } from "../Company/CompanyEntity"

export class CompanyMetaSettingsEntity extends BaseModel {
  id: number

  userId: string

  companyEntityId: number

  isEnabled: boolean

  accountSid: string

  authTokenEncrypted: string

  whatsappFromNumber: string

  isValidated: boolean

  lastConnectionTestAt?: string | null

  lastValidationErrorMessage: string

  isStatusChangedNotificationEnabled: boolean

  isFifteenDaysCampaignEnabled: boolean

  isPrizeNotificationEnabled: boolean

  statusChangedTemplate: string

  fifteenDaysCampaignTemplate: string

  prizeTemplate: string

  fifteenDaysIntervalDays: number

  lastFifteenDaysCampaignRunAt?: string | null

  createdAt: string

  updatedAt: string

  companyEntity?: CompanyEntity | null

  constructor(data: Partial<CompanyMetaSettingsEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.userId = data.userId ?? ""

    this.companyEntityId = data.companyEntityId ?? -1

    this.isEnabled = data.isEnabled ?? false

    this.accountSid = data.accountSid ?? ""

    this.authTokenEncrypted = data.authTokenEncrypted ?? ""

    this.whatsappFromNumber = data.whatsappFromNumber ?? ""

    this.isValidated = data.isValidated ?? false

    this.lastConnectionTestAt = data.lastConnectionTestAt ?? null

    this.lastValidationErrorMessage = data.lastValidationErrorMessage ?? ""

    this.isStatusChangedNotificationEnabled = data.isStatusChangedNotificationEnabled ?? false

    this.isFifteenDaysCampaignEnabled = data.isFifteenDaysCampaignEnabled ?? false

    this.isPrizeNotificationEnabled = data.isPrizeNotificationEnabled ?? false

    this.statusChangedTemplate = data.statusChangedTemplate ?? ""

    this.fifteenDaysCampaignTemplate = data.fifteenDaysCampaignTemplate ?? ""

    this.prizeTemplate = data.prizeTemplate ?? ""

    this.fifteenDaysIntervalDays = data.fifteenDaysIntervalDays ?? 15

    this.lastFifteenDaysCampaignRunAt = data.lastFifteenDaysCampaignRunAt ?? null

    this.createdAt = data.createdAt ?? ""

    this.updatedAt = data.updatedAt ?? ""

    this.companyEntity = data.companyEntity ? new CompanyEntity(data.companyEntity) : null
  }
}
